import { Stack, Typography } from "@mui/material"
import React from "react"
import { Chip } from "../../../../../mp-shared-components/generic-shared-components/components"
import { useStyles } from "./styles"
import { User } from "../../../../../../types/gqlTypes/graphql"
import { LongTextTooltip } from "@masteryprep/mp-shared-components/generic"

interface Props {
  user: User
  onClick: () => void
  autocompleteOptionProps?: any
}

const UserGlobalSearchOption: React.FC<Props> = ({
  user,
  onClick,
  autocompleteOptionProps = {}
}) => {
  const { classes } = useStyles({ deleted: !!user?.deleted })

  return (
    <Stack
      {...autocompleteOptionProps}
      spacing={1}
      className={classes.optionContainer}
      onClick={onClick}
      data-automation-id="searched-user"
    >
      <Typography variant="h6" data-automation-id="searched-user-fullname" className="clarity-mask">
        {user.fullname}
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        <Chip
          size="xs"
          label={user.roles[0]}
          data-automation-id="searched-user-role"
        />
        <LongTextTooltip
          symbolsLimit={25}
          text={
            user.roles[0] === "District Admin"
              ? user.districtName
              : user.schoolName
          }
        >
          {text => (
            <Typography
              variant="caption"
              className={classes.orgName}
              data-automation-id="searched-user-organization"
            >
              {user.deleted ? "Deleted" : text}
            </Typography>
          )}
        </LongTextTooltip>
      </Stack>
    </Stack>
  )
}

export default UserGlobalSearchOption
